import { render, staticRenderFns } from "./DemoInfoSection.vue?vue&type=template&id=fca0db52&"
import script from "./DemoInfoSection.vue?vue&type=script&lang=js&"
export * from "./DemoInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports